export default __webpack_public_path__ + "images/aa9588340a29b43e5b14481c782bd43d-sikhism.webp";